import { Box, useMediaQuery } from "@material-ui/core";
import FigureText from "src/view/PoolMonitoring/Overview/AssetConfigOption/components/FigureText";

export default function SetActivateReserveItem({ data, isActivate }) {
  const matches = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center" flexWrap="wrap">
      <FigureText
        sx={{ display: "flex", alignItems: "baseline" }}
        title="Symbol"
        value={data.symbol}
        mr={matches ? 0 : 8}
        justifyContent={matches ? "space-between" : "flex-start"}
        width={matches ? "100%" : "inherit"}
        style={{ marginBottom: 15 }}
      />
      <FigureText
        sx={{ display: "flex", alignItems: "baseline" }}
        title="Activate"
        value={isActivate ? "True" : "False"}
        mr={matches ? 0 : 8}
        justifyContent={matches ? "space-between" : "flex-start"}
        width={matches ? "100%" : "inherit"}
        style={{ marginBottom: 15 }}
      />
    </Box>
  );
}
